import { Scale, Dna, Atom } from 'lucide-react';
import { Reveal } from './Reveal';
import { PILLARS } from '../data/content';

const ICONS = { legal: Scale, medical: Dna, scientific: Atom };

export const Pillars = () => (
  <section id="pillars" className="py-24 lg:py-32 bg-[#190A0B]">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <Reveal>
        <p className="font-mono text-xs tracking-[0.3em] uppercase text-gold mb-5">Fields of Endeavour</p>
        <h2 className="font-serif font-medium text-4xl sm:text-5xl text-[#F2E5CF] tracking-tight max-w-2xl leading-[1.08]">
          Three disciplines. One unbroken standard of excellence.
        </h2>
      </Reveal>

      <div className="mt-16 grid lg:grid-cols-3 gap-px bg-[#47201F] border border-[#47201F]">
        {PILLARS.map((p, i) => {
          const Icon = ICONS[p.id];
          return (
            <Reveal key={p.id} delay={i * 0.12} className="bg-[#271011]">
              <article
                data-testid={`pillar-card-${p.id}`}
                className="group h-full p-9 lg:p-11 flex flex-col transition-colors duration-500 hover:bg-[#331416]"
              >
                <div className="flex items-start justify-between">
                  <span className="font-mono text-xs tracking-[0.25em] text-[#94756A]">{p.index}</span>
                  <Icon className="w-6 h-6 text-gold transition-transform duration-500 group-hover:-rotate-6 group-hover:scale-110" strokeWidth={1.5} />
                </div>
                <p className="mt-10 font-mono text-[11px] tracking-[0.3em] uppercase text-gold">{p.field}</p>
                <h3 className="mt-3 font-serif font-semibold text-2xl lg:text-[1.7rem] text-[#F2E5CF] leading-snug">{p.title}</h3>
                <p className="mt-5 text-sm sm:text-base text-[#B99C8B] leading-relaxed flex-1">{p.body}</p>
                <div className="mt-8 pt-6 border-t border-[#47201F] flex items-center justify-between">
                  <span className="font-display text-xs font-semibold tracking-widest uppercase text-[#F2E5CF]">{p.stat}</span>
                  <span className="w-8 h-px bg-gold transition-all duration-500 group-hover:w-14" />
                </div>
              </article>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
